import { render, staticRenderFns } from "./FileTypeSelector.vue?vue&type=template&id=ec0c4652"
import script from "./FileTypeSelector.vue?vue&type=script&lang=js"
export * from "./FileTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports